import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, MessageCircle, Mail } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { formatAdminDate } from "@/components/admin/adminShared";

export default function AdminRequests() {
  const [items, setItems] = useState([]);
  const [showHandled, setShowHandled] = useState(false);
  const load = useCallback(() => api.get("/contact").then((r) => setItems(r.data)).catch(() => toast.error("Error carregant sol·licituds.")), []);
  useEffect(() => { load(); }, [load]);
  const toggle = async (c) => { await api.patch(`/contact/${c.id}`, { handled: !c.handled }); load(); };
  const remove = async (c) => {
    if (!window.confirm(`Eliminar la sol·licitud de ${c.name}?`)) return;
    await api.delete(`/contact/${c.id}`); toast.success("Eliminada."); load();
  };
  const visible = items.filter((c) => showHandled || !c.handled);
  const pending = items.filter((c) => !c.handled).length;

  return (
    <div data-testid="admin-requests">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div>
          <p className="uppercase tracking-[0.28em] text-xs text-[#3e664c] mb-2">Reserves de sala</p>
          <h2 className="font-display text-4xl tracking-tight">Sol·licituds</h2>
          <p className="text-sm text-[#5C544F] mt-1" data-testid="requests-pending-count">{pending} pendents de gestionar</p>
        </div>
        <label className="text-sm text-[#5C544F] flex items-center gap-2"><input type="checkbox" checked={showHandled} onChange={(e) => setShowHandled(e.target.checked)} data-testid="requests-show-handled" /> Mostrar gestionades</label>
      </div>
      <div className="space-y-3">
        {visible.map((c) => (
          <div key={c.id} className={`bg-white border rounded-2xl p-5 flex flex-wrap gap-4 items-start ${c.handled ? "border-[#eae0df] opacity-60" : "border-[#C9A24B]/60"}`} data-testid={`request-${c.id}`}>
            <div className="flex-1 min-w-[240px]">
              <p className="font-medium">{c.name} <span className="text-xs text-[#5C544F]">· rebuda {formatAdminDate(c.created_at?.slice(0, 10))}</span></p>
              <p className="text-sm text-[#3e664c]">Data sol·licitada: {c.event_date ? formatAdminDate(c.event_date) : "—"}</p>
              <p className="text-sm text-[#5C544F] mt-2 whitespace-pre-line">{c.message}</p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {c.phone && <a href={`https://wa.me/${c.phone.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs px-3 py-1.5 rounded-full border border-[#3e664c] text-[#3e664c]" data-testid={`request-wa-${c.id}`}><MessageCircle size={13} /> {c.phone}</a>}
              {c.email && <a href={`mailto:${c.email}`} className="inline-flex items-center gap-1 text-xs px-3 py-1.5 rounded-full border border-[#eae0df]"><Mail size={13} /> Email</a>}
              <Button size="sm" onClick={() => toggle(c)} data-testid={`request-toggle-${c.id}`} className={`rounded-full ${c.handled ? "bg-white text-[#3e664c] border border-[#3e664c] hover:bg-[#3e664c]/5" : "bg-[#3e664c] text-white hover:bg-[#2e5949]"}`}>
                {c.handled ? "Marcar pendent" : "Marcar gestionada"}
              </Button>
              <Button size="icon" variant="ghost" onClick={() => remove(c)} data-testid={`request-delete-${c.id}`}><Trash2 size={15} className="text-[#450905]" /></Button>
            </div>
          </div>
        ))}
        {!visible.length && <p className="text-sm text-[#5C544F] py-10 text-center">No hi ha sol·licituds pendents.</p>}
      </div>
      <p className="text-xs text-[#5C544F] mt-6">Per crear l&apos;esdeveniment, ves a la pestanya «Esdeveniments». A AURA Manager aquestes sol·licituds apareixen al CRM.</p>
    </div>
  );
}
